import { EasingFunction } from '../types';
import { AnimationEngine } from '../core/AnimationEngine';

export abstract class BaseAnimation {
  public target: any;
  public easing: EasingFunction;

  constructor(target: any, easing: EasingFunction = AnimationEngine.Easings.easeInOutCubic) {
    this.target = target;
    this.easing = easing;
  }

  /**
   * Called by Timeline with linear progress [0..1]
   */
  public evaluate(rawProgress: number): void {
    const clamped = Math.max(0, Math.min(1, rawProgress));
    const easedProgress = this.easing(clamped);
    this.update(easedProgress);
  }

  protected abstract update(progress: number): void;
}
